const host = {
    local: {
        oss: '/',
        flashrent: '/',
        flashrentUploadUrl: '/saasossplatform/flashrent/uploadImage/',
        // saasmsg: 'https://localhost:21001/',
        saasmsg: 'https://fangnotice.dev.hzfapi.com/',
        // bpm: 'http://127.0.0.1:12351'
        bpm: 'https://bpm.dev.hzfapi.com/bpm/api/',
    },
    dev: {
        oss: 'https://saasoss.dev.hzfapi.com/',
        flashrent: 'https://fangshanzu.dev.hzfapi.com/',
        flashrentUploadUrl: '/saasossplatform/flashrent/uploadImage/',
        saasmsg: 'https://fangnotice.dev.hzfapi.com/',
        bpm: 'https://bpm.dev.hzfapi.com/bpm/api/',
        qfthouse: 'https://qfthouse.dev.hzfapi.com',
    },
    staging2: {
        oss: 'https://saasoss.staging2.hzfapi.com/',
        flashrent: 'https://fangshanzu.staging2.hzfapi.com',
        flashrentUploadUrl: '/saasossplatform/flashrent/uploadImage/',
        saasmsg: 'https://fangnotice.staging2.hzfapi.com/',
        bpm: 'https://bpm.staging2.hzfapi.com/bpm/api/',
        qfthouse: 'https://qfthouse.staging2.hzfapi.com',
    }, staging3: {
        oss: 'https://saasoss.staging3.hzfapi.com/',
        flashrent: 'https://fangshanzu.staging3.hzfapi.com',
        flashrentUploadUrl: '/saasossplatform/flashrent/uploadImage/',
        saasmsg: 'https://fangnotice.staging3.hzfapi.com/',
        bpm: 'https://bpm.staging2.hzfapi.com/bpm/api/',
        qfthouse: 'https://qfthouse.staging3.hzfapi.com'
    },
    pre: {
        oss: 'https://saasoss.pre.hzfapi.com/',
        flashrent: 'https://fangshanzu.pre.hzfapi.com/',
        flashrentUploadUrl: '/saasossplatform/flashrent/uploadImage/',
        saasmsg: 'https://fangnotice.pre.hzfapi.com/',
        hyx: 'https://huiyingxiao.pre.hzfapi.com/api/',
        bpm: 'https://bpm.quanfangtongvip.com/bpm/api/',
        qfthouse: 'https://qfthouse.pre.hzfapi.com'
    },
    prod: {
        oss: 'https://saasoss.huizhaofang.com/',
        flashrent: 'https://fangshanzu.huizhaofang.com/',
        flashrentUploadUrl: '/saasossplatform/flashrent/uploadImage/',
        saasmsg: 'https://fangnotice.huizhaofang.com/',
        bpm: 'https://bpm.quanfangtongvip.com/bpm/api/',
        qfthouse: 'https://qfthouse.huizhaofang.com'
    }
};

function setConfig(BUILD_ENV) {
    let hosts = host[BUILD_ENV || 'local'];
    console.log(hosts);
    window && (window.hostConfig = hosts);
    return hosts;
}
module.exports = host;



//////////////////
// WEBPACK FOOTER
// ./config/host.config.js
// module id = zq1Z
// module chunks = 86